import { Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

export function ConcludedStep() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <section>
        <CheckCircleIcon />
        <Typography variant={'h2'}>Confirmação realizada.</Typography>
        <Typography variant={'h2'}>
          Status da atividade alterado no calendário.
        </Typography>
      </section>

      <div className={classes.inputsContainer}>
        <div className={classes.buttonsContainer}>
          <Button outlined component={Link} to={routes.ActivityAdd()}>
            Agendar nova atividade
          </Button>
          <Button component={Link} to={routes.Activities()}>
            Ir ao calendário
          </Button>
        </div>
      </div>
    </div>
  )
}
